import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setLastMonth,
  setToday,
} from "../../../../common/redux/action/ToDayAction";
import {
  getCurrentDate,
  getLastMonthDate,
} from "../../../../util/DateCalculation";
import emailLogin from "../repo/EmailLogin";
import { isValidEmail } from "../../../../util/const";
import { getReUrlData } from "../../../CreateButton/Renewal/repo/UrlData";
import { setButtonUrl } from "../../../../common/redux/action/UrlButtonAction";
import { useTranslation } from "react-i18next";
import { setLanguage } from "../../../../common/redux/action/languageAction";
import { handleProfileData } from "../../components/LoginCommon";
import { API_URL } from "../../../../Repository/URL";
import {
  GrayLine,
  HeaderButton,
  HeaderButton2,
  HeaderLogoIconBox,
  HeaderLogoIconBox2,
  LoginSignUpButton,
  LoginSignUpButton2,
  MakeButton,
  MakeButtonKo,
  ReImgDefault,
  ReLoginBackground,
  ReLoginBlackText,
  ReLoginBodyBox,
  ReLoginContent,
  ReLoginContent2,
  ReLoginContentTitle,
  ReLoginEndBoxText,
  ReLoginFlexBox,
  ReLoginFlexBox2,
  ReLoginFontWeight,
  ReLoginGraySpanText,
  ReLoginHeader,
  ReLoginIconBox,
  ReLoginMinuteText,
  ReLoginSideImage,
  ReLoginSizeBox,
  ReLoginSubTitle,
  ReLoginSubTitleKo,
  ReLoginTextOneBox,
  ReLoginTopBody,
  ReLoginTopText,
  ResponsiveBr,
  ResponsiveSpan,
  ResponsiveSpan2,
} from "../css/RenewalLoginStyled";
import "../css/RenewalLoginStyled";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaCircle } from "react-icons/fa";

import kobuttonimg from "../img/en/LeftEnButton.svg";
import kobuttonimg2 from "../img/en/ButtonYellow.svg";
import kobuttonimgkr from "../img/ko/koCreateButton.svg";
import kobuttonimgkr2 from "../img/ko/KoCreateButton2.svg";
import hazanGuide from "../img/en/hanzan.webp";
import hazanGuideKo from "../img/hazanGuideKo.webp";
import insta from "../img/insta.webp";
import youtube from "../img/youtube.webp";
import tree from "../img/tree.webp";
import word from "../img/word.webp";
import { IoArrowRedoCircle } from "react-icons/io5";
import guideOne from "../img/guideOne.webp";
import guideTwo from "../img/guideImg.png";
import guideThree from "../img/Group 62@2x.png";
import icon from "../img/IconR.svg";
import ReFooter from "../../../../common/Footer/screen/ReFooter";
import { Toggle } from "../../../../util/toggle";
import blogIcon from "../img/blog.webp";
import tStory from "../img/story.svg";
import guideKO from "../img/ko/koFunalGuide.svg";
import guideEn from "../img/guideEn.svg";
import guideEnImg from "../img/en/enFinalGuide.svg";
import { useLocation } from "react-router-dom";

const ReLoginPage = () => {
  const { t, i18n } = useTranslation();


  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
  
    const setMeta = (attr, name, content) => {
      let tag = document.querySelector(`meta[${attr}="${name}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attr, name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };
    const setSEO = (lang) => {
      const title = lang === "ko" ? "후원한잔 - Hanzan" : "Hanzan";
      const desc =
        lang === "ko"
          ? "세상에 선한 영향력을 끼치는 디지털 크리에이터들에게 커피 값 만큼 소액 후원을 할 수 있는 도네이션 서비스"
          : "A donation service that allows you to make small contributions—like the cost of a cup of coffee—to digital creators who make a positive impact on the world";
  
      document.title = title;
      setMeta("name", "description", desc);
      setMeta("property", "og:title", title);
      setMeta("property", "og:description", desc);
      setMeta("name", "twitter:title", title);
      setMeta("name", "twitter:description", desc);
    };
    if (pathname === "/renewalLogin/en") {
      i18n.changeLanguage("en");
      setSEO("en");
    } else if (pathname === "/renewalLogin/ko") {
      i18n.changeLanguage("ko");
      setSEO("ko");
    }
    }, [location.pathname]);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [isVerySmallScreen, setIsVerySmallScreen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);

      setIsSmallScreen(window.innerWidth <= 500);
      setIsVerySmallScreen(window.innerWidth <= 420);
    };

    window.addEventListener("resize", handleResize);
    // 초기 화면 크기에 따라 설정
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const languageData = useSelector((state) => state.languageType.type);
  useEffect(() => {
    const languagePrefix = i18n.language.split("-")[0];
    dispatch(setLanguage(languagePrefix));
  }, [i18n.language]);

  const toggleLanguage = () => {
    const newLanguage = ["ko", "ko-KR"].includes(i18n.language) ? "en" : "ko";
    // const newLanguage = i18n.language === "ko" ? "en" : "ko";

    i18n.changeLanguage(newLanguage);
  };

  const [isUserId, setUserId] = useState("");
  const [isPassword, setPassword] = useState("");
  const [isUserIdCheck, setUserIdCheck] = useState(false);
  const [isNoIdPassword, setNoIdPassword] = useState(false);
  const [isNetWorkError, setNetWorkError] = useState(false);

  const Kakao = window.Kakao;
  const initKakao = () => {
    const jsKey = "e3300a732962de06d88af3e686dcadc3";
    // const Kakao = window.Kakao;
    if (Kakao && !Kakao.isInitialized()) {
      Kakao.init(jsKey);
      // console.log(Kakao.isInitialized());
    }
  };
  useEffect(() => {
    initKakao();
  }, []);

  const handleUserId = (e) => {
    setUserId(e.target.value);
  };

  const handleUserPassword = (e) => {
    setPassword(e.target.value);
  };

  const kakaoHandleLogin = async () => {
    const currentDay = getCurrentDate();
    const lastDay = getLastMonthDate();
    dispatch(setLastMonth(lastDay.year, lastDay.month, lastDay.day));
    dispatch(setToday(currentDay.year, currentDay.month, currentDay.day));
    Kakao.Auth.authorize({
      redirectUri: `${API_URL}/kakaoLogin`,
      state: "sendfriend_feed",
      scope: "profile_nickname,account_email,profile_image,phone_number,name",
      nonce: "ceazer",
    });
  };

  const loginHandle = async (id, password) => {
    const currentDay = getCurrentDate();
    const lastDay = getLastMonthDate();

    /// 유효성 검사
    if (!isValidEmail(id)) {
      setUserIdCheck(true);
      return;
    }

    if (isValidEmail(id)) {
      setUserIdCheck(false);
    }

    try {
      const resp = await emailLogin(id, password);

      if (resp === true) {
        const buttonURL = await getReUrlData();
        dispatch(setButtonUrl(buttonURL.data));
        dispatch(setLastMonth(lastDay.year, lastDay.month, lastDay.day));
        dispatch(setToday(currentDay.year, currentDay.month, currentDay.day));

        await handleProfileData(dispatch, navigate);
      } else {
        if (resp.error.status_code === 400) {
          setNoIdPassword(true);
        }
        if (resp.error.status_code === 500) {
          setNetWorkError(true);
        }
        return;
      }
    } catch (error) {
      console.log("로그인 오류", error);
      return;
    }
  };

  const signUpHandle = () => {
    navigate("/ReSignUpPage");
  };
  const loginPageHandle = () => {
    navigate("/renewalLogin2");
  };
  const findPasswordHandle = () => {
    navigate("/FindPassword");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await loginHandle(isUserId, isPassword);
  };

  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const calculateLeft = () => {
    const minScroll = 0;
    const maxScroll = 300;
    const minLeft = 0;
    const maxLeft = -70;

    const clampedScroll = Math.min(Math.max(scrollY, minScroll), maxScroll);
    const ratio = clampedScroll / maxScroll;

    const interpolatedLeft = minLeft + (maxLeft - minLeft) * ratio;
    return `${interpolatedLeft}%`;
  };

  const calculateRight = () => {
    const minScroll = 0;
    const maxScroll = 300;
    const minRight = 0; // ✅ 여기! 0 → -10으로 바꿔라
    const maxRight = -70;

    const clamped = Math.min(Math.max(scrollY, minScroll), maxScroll);
    const ratio = clamped / maxScroll;

    const value = minRight + (maxRight - minRight) * ratio;
    return `${value}%`;
  };
  const bgColor = scrollY > 250 ? "#faf8f0" : "white";

  return (
    <ReLoginBackground $bgColor={bgColor}>
      <ReLoginHeader>
        <ReLoginFlexBox2 $width="210px">
          {/* <HeaderLogoIconBox>
            <ReImgDefault src="/group.svg"></ReImgDefault>
          </HeaderLogoIconBox>
          <HeaderLogoIconBox2>
            <ReImgDefault
              src={languageData === "en" ? "/GroupEn.svg" : "/LogoBlack.svg"}
            ></ReImgDefault>
          </HeaderLogoIconBox2> */}
          {windowWidth >= 1200 ? (
            <HeaderButton2
              onClick={() => {
                window.open(
                  "https://splendid-tuberose-a37.notion.site/HANZAN-Guideline-989ae6831bf7416688d4375c78e7bf1d",
                  "_blank"
                );
              }}
            >
              {languageData === "en" ? "Hanzan Guide" : "후원한잔 가이드"}
            </HeaderButton2>
          ) : (
            <div style={{ display: `flex` }}>
              <HeaderLogoIconBox>
                <ReImgDefault src="/group.svg"></ReImgDefault>
              </HeaderLogoIconBox>
              <HeaderLogoIconBox2>
                <ReImgDefault
                  src={
                    languageData === "en" ? "/GroupEn.svg" : "/LogoBlack.svg"
                  }
                ></ReImgDefault>
              </HeaderLogoIconBox2>
            </div>
          )}
        </ReLoginFlexBox2>
        {windowWidth >= 1200 && (
          <div style={{ display: `flex` }}>
            <HeaderLogoIconBox>
              <ReImgDefault src="/group.svg"></ReImgDefault>
            </HeaderLogoIconBox>
            <HeaderLogoIconBox2>
              <ReImgDefault
                src={languageData === "en" ? "/GroupEn.svg" : "/LogoBlack.svg"}
              ></ReImgDefault>
            </HeaderLogoIconBox2>
          </div>
        )}
        <ReLoginFlexBox align="center">
          {languageData === "en" ? (
            <HeaderButton2 onClick={() => loginPageHandle()}>
              Log in
            </HeaderButton2>
          ) : (
            <HeaderButton2 onClick={() => loginPageHandle()}>
              로그인
            </HeaderButton2>
          )}

          <HeaderButton onClick={() => signUpHandle()} $marginRight="0px">
            {languageData === "en" ? "Sign up" : "회원가입"}
          </HeaderButton>
        </ReLoginFlexBox>
      </ReLoginHeader>
      <div
        style={{
          zIndex: `10`,
          marginTop: `80px`,
          display: `flex`,
          alignItems: `center`,
          justifyContent: `end`,
          width: `100%`,
          backgroundColor: `transparent`,
          paddingRight: `40px`,
        }}
      >
        <Toggle defaultChecked={false} onChange={toggleLanguage} />
      </div>
      <ReLoginBodyBox>
        {languageData === "en" ? (
          <ReLoginSideImage
            style={{
              maxWidth: `100vh`,
            }}
            $left={calculateLeft()}
            $top="15%"
            rotate={-5}
            $visible={scrollY <= 250 && windowWidth >= 750}
          >
            <img
              src={kobuttonimg}
              style={{
                width: `65vh`,
                // height: `50px`,
              }}
            />
          </ReLoginSideImage>
        ) : (
          <ReLoginSideImage
            style={{
              maxWidth: `100vh`,
            }}
            $left={calculateLeft()}
            $top="15%"
            rotate={-5}
            $visible={scrollY <= 250 && windowWidth >= 750}
          >
            <img
              src={kobuttonimgkr}
              style={{
                width: `65vh`,
                // height: `50px`,
              }}
            />
          </ReLoginSideImage>
        )}
        {languageData === "en" ? (
          <ReLoginSideImage
            $right={calculateRight()}
            $top="45%"
            rotate={-5}
            $visible={scrollY <= 250 && windowWidth >= 750}
          >
            <img
              src={kobuttonimg2}
              style={{
                width: `65vh`,
              }}
            />
          </ReLoginSideImage>
        ) : (
          <ReLoginSideImage
            style={{
              maxWidth: `100vh`,
            }}
            $right={calculateRight()}
            $top="45%"
            rotate={-5}
            $visible={scrollY <= 250 && windowWidth >= 750}
          >
            <img
              src={kobuttonimgkr2}
              style={{
                width: `65vh`,
                // height: `50px`,
              }}
            />
          </ReLoginSideImage>
        )}

        <ReLoginTopBody>
          {languageData === "en" ? (
            <>
              <ReLoginTopText>Hanzan for you</ReLoginTopText>
              <div
                style={
                  {
                    // height: `2rem`,
                  }
                }
              ></div>
              <ReLoginTextOneBox>
                <ReLoginSubTitle>
                   Your readers{" "}
                  <span style={{ fontWeight: `600` }}>support</span> your work.
                  You keep{" "}
                  <span
                    style={{
                      fontWeight: `600`,
                    }}
                  >
                    creating
                  </span>{" "}
                  inspiring content.
                  {windowWidth >= 1100 && <br />}
                  Your readers{" "}
                  <span
                    style={{
                      fontWeight: `600`,
                    }}
                  >
                    enjoy
                  </span>{" "}
                  richer, happier lives. And everyone{" "}
                  <span
                    style={{
                      fontWeight: `600`,
                    }}
                  >
                    benefits.
                  </span>
                </ReLoginSubTitle>
              </ReLoginTextOneBox>
              <div
                style={{
                  zIndex: `11`,
                }}
              >
                <MakeButton onClick={() => loginPageHandle()}>
                  Make your own
                </MakeButton>
              </div>
            </>
          ) : (
            <>
              <ReLoginTopText>
                마음을 전하는
                <br></br> 따뜻한 후원 한 잔
              </ReLoginTopText>
              <ReLoginTextOneBox>
                <ReLoginSubTitle>
                   창작자에게 큰 힘이 되는 응원.
                  {windowWidth >= 1100 && <br />} 저희 서비스가 그 마음을 전하는
                  따뜻한 공간이 되길 바랍니다. {windowWidth >= 1100 && <br />}
                  여러분들의 창작 생활에 저희 후원한잔이 함께하겠습니다 :)
                </ReLoginSubTitle>
              </ReLoginTextOneBox>
              <div
                style={{
                  zIndex: `11`,
                }}
              >
                <MakeButton onClick={() => loginPageHandle()}>
                  시작하기
                </MakeButton>
              </div>
            </>
          )}

          {languageData === "en" ? (
            <>
              <ReLoginFlexBox $justify="center">
                <ReLoginMinuteText>
                  We've prepared a cup just for you!
                </ReLoginMinuteText>
              </ReLoginFlexBox>
            </>
          ) : (
            <>
              <ReLoginFlexBox $justify="center">
                <ReLoginMinuteText>
                  당신을 위한 한 잔이 준비되어 있습니다 :)
                </ReLoginMinuteText>
              </ReLoginFlexBox>
            </>
          )}
        </ReLoginTopBody>
        {/* 가이드 1 */}
        <ReLoginContent>
          <ReLoginContentTitle>
            {languageData === "en"
              ? "What is HANZAN?"
              : "후원한잔은 어떤 서비스인가요?"}
          </ReLoginContentTitle>
          <div>
            <img src={languageData === "en" ? hazanGuide : hazanGuideKo} />
          </div>
        </ReLoginContent>
        {/* 가이드 2 */}

        {languageData === "en" ? (
          <>
            <ReLoginContent>
              <ReLoginContentTitle>
                How to Receive Sponsorship?
              </ReLoginContentTitle>
              <ReLoginBlackText>
                <ResponsiveSpan>
                   Create a sponsorship link (button) on the (
                  <ReLoginGraySpanText
                    onClick={() =>
                      window.open("https://acoffee.shop", "_blank")
                    }
                  >
                    https://acoffee.shop
                  </ReLoginGraySpanText>
                  ) to receive sponsorships.
                </ResponsiveSpan>
                <ResponsiveSpan>
                   Add the sponsorship link (button) to your Instagram, YouTube,
                  or blog.
                </ResponsiveSpan>
                <ResponsiveSpan>
                   Sponsors can use this link (button) to navigate to your
                  sponsorship page and make donations.
                </ResponsiveSpan>
              </ReLoginBlackText>
            </ReLoginContent>
            <ReLoginContent>
              <ReLoginContentTitle>
                How to Create a Sponsorship Link (Button)?
              </ReLoginContentTitle>
              <ReLoginBlackText>
                <ResponsiveSpan>
                   You can create it in the "Create Button" tab on the official
                  (
                  <ReLoginGraySpanText
                    onClick={() =>
                      window.open("https://acoffee.shop", "_blank")
                    }
                  >
                    https://acoffee.shop{" "}
                  </ReLoginGraySpanText>
                  )
                </ResponsiveSpan>
                <ResponsiveSpan>
                   Customize the sponsorship link (button) to match the platform
                  you are active on!
                </ResponsiveSpan>
                <ReLoginSizeBox $height="40px"></ReLoginSizeBox>
                <a
                  href="https://splendid-tuberose-a37.notion.site/How-to-add-a-HANZAN-button-to-your-Instagram-82285226e65d4b158cfe5b75de5bacaf"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <ReLoginFlexBox $align="center">
                    <ReLoginIconBox>
                      <ReImgDefault src={insta} />
                    </ReLoginIconBox>
                    <div>
                      <ResponsiveSpan>
                        How to add a HANZAN button to your Instagram
                      </ResponsiveSpan>
                      <GrayLine />
                    </div>
                  </ReLoginFlexBox>
                </a>
                <ReLoginSizeBox $height="10px"></ReLoginSizeBox>
                <a
                  href="https://splendid-tuberose-a37.notion.site/How-to-add-a-HANZAN-button-to-your-Youtube-296667537e6b4a51a8d9057c23fcbd66"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <ReLoginFlexBox $align="center">
                    <ReLoginIconBox>
                      <ReImgDefault src={youtube} />
                    </ReLoginIconBox>
                    <div>
                      <ResponsiveSpan>
                        How to add a HANZAN button to your Youtube
                      </ResponsiveSpan>
                      <GrayLine />
                    </div>
                  </ReLoginFlexBox>
                </a>
                <ReLoginSizeBox $height="10px"></ReLoginSizeBox>
                <a
                  href="https://splendid-tuberose-a37.notion.site/How-to-add-a-HANZAN-button-to-your-Linktree-7c18dbf982ca485ebc38bcd2a3bc35be"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <ReLoginFlexBox $align="center">
                    <ReLoginIconBox>
                      <ReImgDefault src={tree} />
                    </ReLoginIconBox>
                    <div>
                      <ResponsiveSpan>
                        How to add a HANZAN button to your Linktree
                      </ResponsiveSpan>
                      <GrayLine />
                    </div>
                  </ReLoginFlexBox>
                </a>
                <ReLoginSizeBox $height="10px"></ReLoginSizeBox>
                <a
                  href="https://splendid-tuberose-a37.notion.site/How-to-add-a-HANZAN-button-to-your-WordPress-site-59d5d8e0b5d448bcb9429c6eabf40693"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <ReLoginFlexBox $align="center">
                    <ReLoginIconBox>
                      <ReImgDefault src={word} />
                    </ReLoginIconBox>
                    <div>
                      <ResponsiveSpan>
                        How to add a HANZAN button to your WordPress site
                      </ResponsiveSpan>
                      <GrayLine />
                    </div>
                  </ReLoginFlexBox>
                </a>

                <ReLoginSizeBox $height="40px"></ReLoginSizeBox>
                <div
                  style={{
                    backgroundColor: `#F5F5F5`,
                    width: `100%`,
                    padding: `20px`,
                    borderRadius: `8px`,
                    display: `flex`,
                    alignItems: `start`,
                    // alignItems: `center`,
                  }}
                >
                  <div
                    style={{
                      display: `flex`,
                      alignItems: `center`,
                      marginTop: `5px`,
                      minWidth: `20px`,
                      minHeight: `20px`,
                    }}
                  >
                    <IoMdCheckmarkCircleOutline size={20} color="#F8D600" />
                  </div>
                  <ReLoginSizeBox $height="0px"></ReLoginSizeBox>
                  <ResponsiveSpan>
                    If you find it difficult to use, feel free to contact us
                    through our official Email(
                    <ReLoginGraySpanText>
                      xrai.inc@gmail.com
                    </ReLoginGraySpanText>
                    )
                  </ResponsiveSpan>
                </div>
              </ReLoginBlackText>
            </ReLoginContent>
            {/* 가이드 3 */}
            <ReLoginContent>
              <ReLoginContentTitle>
                How to Check Received Sponsorships?
              </ReLoginContentTitle>
              <ReLoginBlackText>
                <ResponsiveSpan>
                  Log in to the Sponsorship Page > Check the Sponsorship Status
                  (Home Screen) tab to see the latest sponsors!
                </ResponsiveSpan>
                <ResponsiveSpan
                  style={{
                    display: `flex`,
                    alignItems: `center`,
                    marginTop: `20px`,
                  }}
                >
                  ◼︎ Sponsorship Status Screen
                </ResponsiveSpan>
                <div
                  style={{
                    marginTop: `20px`,
                  }}
                >
                  {/* 여기임 */}
                  <img
                    src={guideEnImg}
                    style={{
                      width: `100%`,
                    }}
                  />
                </div>
                <ReLoginSizeBox $height="30px" />
                <ReLoginFlexBox $align="center">
                  <ResponsiveSpan>
                    ∙ You can view your support amount and payout amount history
                    from the past 3 months.
                  </ResponsiveSpan>
                </ReLoginFlexBox>

                <ReLoginFlexBox $align="center">
                  <ResponsiveSpan>
                    ∙ You can check the pending payout amount for this month.
                  </ResponsiveSpan>
                </ReLoginFlexBox>
                <ReLoginFlexBox $align="center">
                  <ResponsiveSpan>
                    ∙ You can view the supporter’s name, the support amount, the
                    date, and the message.
                  </ResponsiveSpan>
                </ReLoginFlexBox>
              </ReLoginBlackText>
            </ReLoginContent>
            {/* 가이드 4 */}
            <ReLoginContent>
              <ReLoginContentTitle>Is the Service Free? </ReLoginContentTitle>
              <ReLoginBlackText>
                <ResponsiveSpan>
                   Membership registration, creating sponsorship links
                  (buttons), and receiving sponsorships are all free!
                </ResponsiveSpan>
                <ResponsiveSpan>
                   A 4% fee per transaction is applied to support the continued
                  development of our platform. Transparent and fair pricing —
                  compare us with others and see the difference.
                </ResponsiveSpan>
              </ReLoginBlackText>
            </ReLoginContent>
            {/* 가이드 5 */}
            <ReLoginContent2>
              <ReLoginBlackText>
                <ReLoginEndBoxText>
                   We believe that through our brand
                  <ReLoginFontWeight>
                    {" "}
                    ‘HANZAN’, small acts of kindness
                  </ReLoginFontWeight>{" "}
                  can create{" "}
                  <ReLoginFontWeight>
                    significant change.
                    <ResponsiveBr />
                    Creators,
                  </ReLoginFontWeight>{" "}
                  empowered by our{" "}
                  <ReLoginFontWeight>donations,</ReLoginFontWeight> can unleash
                  their{" "}
                  <ReLoginFontWeight>creativity and passion,</ReLoginFontWeight>{" "}
                  <ResponsiveBr />
                  finding{" "}
                  <ReLoginFontWeight>
                    strength and motivation
                  </ReLoginFontWeight>{" "}
                  even in the{" "}
                  <ReLoginFontWeight>
                    smallest acts of giving. <ResponsiveBr />
                  </ReLoginFontWeight>{" "}
                  We believe that{" "}
                  <ReLoginFontWeight>
                    small but meaningful donations
                  </ReLoginFontWeight>{" "}
                  can collectively generate a{" "}
                  <ReLoginFontWeight>
                    substantial social impact.
                  </ReLoginFontWeight>
                </ReLoginEndBoxText>
              </ReLoginBlackText>
            </ReLoginContent2>
          </>
        ) : (
          <>
            <ReLoginContent>
              <ReLoginContentTitle>후원은 어떻게 받나요?</ReLoginContentTitle>
              <ReLoginBlackText>
                <ResponsiveSpan>
                   후원한잔 홈페이지(
                  <ReLoginGraySpanText
                    onClick={() =>
                      window.open("https://acoffee.shop", "_blank")
                    }
                  >
                    https://acoffee.shop
                  </ReLoginGraySpanText>
                  ) 후원링크(버튼)을 생성하여 후원을 받을 수 있어요.
                </ResponsiveSpan>
                <ResponsiveSpan>
                   후원링크(버튼)을 Instagram, YouTube, Blog 등에 추가해주세요.
                </ResponsiveSpan>
                <ResponsiveSpan>
                   후원자들은 해당 후원링크(버튼)을 통해 후원페이지로 이동하여
                  후원할 수 있어요.
                </ResponsiveSpan>
              </ReLoginBlackText>
            </ReLoginContent>
            <ReLoginContent>
              <ReLoginContentTitle>
                후원링크(버튼)는 어떻게 생성하나요?
              </ReLoginContentTitle>
              <ReLoginBlackText>
                <ResponsiveSpan>
                   후원한잔 공식 홈페이지 (
                  <ReLoginGraySpanText
                    onClick={() =>
                      window.open("https://acoffee.shop", "_blank")
                    }
                  >
                    https://acoffee.shop{" "}
                  </ReLoginGraySpanText>
                  )로그인 > 버튼만들기 탭에서 만들 수 있어요
                </ResponsiveSpan>
                <ResponsiveSpan>
                   크리에이터님이 활동하고 계시는 플랫폼에 맞게 후원링크(버튼)을
                  추가해보세요!
                </ResponsiveSpan>
                <ReLoginSizeBox $height="40px"></ReLoginSizeBox>
                <a
                  href="https://onemorelatte.oopy.io/6c0808e0-442b-4e19-9e78-a5a805628af3"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <ReLoginFlexBox $align="center">
                    <ReLoginIconBox>
                      <ReImgDefault src={insta} />
                    </ReLoginIconBox>
                    <div>
                      <ResponsiveSpan>
                        Instagram에 후원링크(버튼) 추가하기
                      </ResponsiveSpan>
                      <GrayLine />
                    </div>
                  </ReLoginFlexBox>
                </a>
                <ReLoginSizeBox $height="10px"></ReLoginSizeBox>
                <a
                  href="https://onemorelatte.oopy.io/82585235-746b-4ec8-8313-4e774253df4f"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <ReLoginFlexBox $align="center">
                    <ReLoginIconBox>
                      <ReImgDefault src={youtube} />
                    </ReLoginIconBox>
                    <div>
                      <ResponsiveSpan>
                        YouTube에 후원링크(버튼) 추가하기
                      </ResponsiveSpan>
                      <GrayLine />
                    </div>
                  </ReLoginFlexBox>
                </a>
                <ReLoginSizeBox $height="10px"></ReLoginSizeBox>
                <a
                  href="https://onemorelatte.oopy.io/a6f6e85a-edc1-463c-ba2e-1406df79e234"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <ReLoginFlexBox $align="center">
                    <ReLoginIconBox>
                      <ReImgDefault src={tree} />
                    </ReLoginIconBox>
                    <div>
                      <ResponsiveSpan>
                        링크트리에 후원링크(버튼) 추가하기
                      </ResponsiveSpan>
                      <GrayLine />
                    </div>
                  </ReLoginFlexBox>
                </a>
                <ReLoginSizeBox $height="10px"></ReLoginSizeBox>
                <a
                  href="https://onemorelatte.oopy.io/d3843ea4-efb8-404b-8786-1a1a8f951d23"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <ReLoginFlexBox $align="center">
                    <ReLoginIconBox>
                      <ReImgDefault src={word} />
                    </ReLoginIconBox>
                    <div>
                      <ResponsiveSpan>
                        워드프레스에 후원링크(버튼) 추가하기
                      </ResponsiveSpan>
                      <GrayLine />
                    </div>
                  </ReLoginFlexBox>
                </a>
                <ReLoginSizeBox $height="10px"></ReLoginSizeBox>
                <a
                  href="https://onemorelatte.oopy.io/bb2fea7b-e7b7-4b43-9488-83edf22ee56c"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <ReLoginFlexBox $align="center">
                    <ReLoginIconBox>
                      <ReImgDefault src={blogIcon} />
                    </ReLoginIconBox>
                    <div>
                      <ResponsiveSpan>
                        블로그에 후원링크(버튼) 추가하기
                      </ResponsiveSpan>
                      <GrayLine />
                    </div>
                  </ReLoginFlexBox>
                </a>
                <ReLoginSizeBox $height="10px"></ReLoginSizeBox>
                <a
                  href="https://onemorelatte.oopy.io/3d0c7e04-1f52-4316-891b-3caffb3542bb"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <ReLoginFlexBox $align="center">
                    <ReLoginIconBox>
                      <ReImgDefault src={tStory} />
                    </ReLoginIconBox>
                    <div>
                      <ResponsiveSpan>
                        티스토리에 후원링크(버튼) 추가하기
                      </ResponsiveSpan>
                      <GrayLine />
                    </div>
                  </ReLoginFlexBox>
                </a>

                <ReLoginSizeBox $height="40px"></ReLoginSizeBox>
                <div
                  style={{
                    backgroundColor: `#F5F5F5`,
                    width: `100%`,
                    padding: `20px`,
                    borderRadius: `8px`,
                    display: `flex`,
                    alignItems: `center`,
                  }}
                >
                  <IoMdCheckmarkCircleOutline size={20} color="#F8D600" />
                  <ReLoginSizeBox $height="0px"></ReLoginSizeBox>
                  <ResponsiveSpan2
                    style={{
                      fontWeight: `500`,
                    }}
                  >
                    사용 방법이 어려우시다면{" "}
                    <span
                      style={{
                        cursor: `pointer`,
                        fontWeight: `800`,
                      }}
                      onClick={() => {
                        window.open("https://pf.kakao.com/_QeXXG", "_blank");
                      }}
                    >
                      후원한잔 카카오채널
                    </span>
                    을 통해 언제든 문의주세요!
                  </ResponsiveSpan2>
                </div>
              </ReLoginBlackText>
            </ReLoginContent>
            {/* 가이드 3 */}
            <ReLoginContent>
              <ReLoginContentTitle>
                받은 후원은 어떻게 확인하나요?
              </ReLoginContentTitle>
              <ReLoginBlackText>
                <ResponsiveSpan>
                  후원한잔 홈페이지 로그인{" "}
                  <span style={{ fontWeight: `800` }}>> 후원상태(홈화면)</span>{" "}
                  탭에서 최근에 후원한 사람들을 확인할 수 있어요!
                </ResponsiveSpan>
                <ResponsiveSpan
                  style={{
                    display: `flex`,
                    alignItems: `center`,
                    marginTop: `20px`,
                  }}
                >
                  {/* <IoArrowRedoCircle
                    style={{
                      marginRight: `10px`,
                    }}
                  /> */}
                  ◼︎ 후원상태 화면
                </ResponsiveSpan>
                <div
                  style={{
                    marginTop: `20px`,
                  }}
                >
                  <img src={guideKO} />
                </div>
                <ReLoginSizeBox $height="30px" />
                <ReLoginFlexBox $align="center">
                  <ResponsiveSpan>
                    ∙ 최근 3개월 간의 후원금액과 정산금액을 확인할 수 있어요.
                  </ResponsiveSpan>
                </ReLoginFlexBox>

                <ReLoginFlexBox $align="center">
                  <ResponsiveSpan>
                    ∙ 이번 달의 정산 예정 금액을 확인할 수 있어요.
                  </ResponsiveSpan>
                </ReLoginFlexBox>
                <ReLoginFlexBox $align="center">
                  <ResponsiveSpan>
                    ∙ 후원자의 이름, 후원 금액, 날짜, 그리고 메시지를 볼 수
                    있어요.
                  </ResponsiveSpan>
                </ReLoginFlexBox>
              </ReLoginBlackText>
            </ReLoginContent>
            {/* 가이드 4 */}
            <ReLoginContent>
              <ReLoginContentTitle>
                서비스 사용은 무료인가요?
              </ReLoginContentTitle>
              <ReLoginBlackText>
                <ResponsiveSpan>
                   회원가입과 후원 링크(버튼) 생성, 후원 받기 기능은 모두
                  무료입니다.
                </ResponsiveSpan>
                <ResponsiveSpan>
                   플랫폼의 지속적인 발전을 위해 거래 시 4%의 수수료가
                  부과됩니다.
                </ResponsiveSpan>
                <ResponsiveSpan>
                   더욱 저렴한 수수료로, 소중한 마음을 전달합니다.
                </ResponsiveSpan>
                <ResponsiveSpan>
                   타사와 바교해 보시고 직접 확인해 보세요.
                </ResponsiveSpan>
              </ReLoginBlackText>
            </ReLoginContent>
            {/* 가이드 5 */}
            <ReLoginContent2>
              <ReLoginBlackText>
                <ReLoginEndBoxText>
                  후원한잔은 모든 창작자의 창작 활동을 진심으로 응원합니다.
                  <br />
                  따뜻한 후원과 함께, 행복하고 의미 있는 창작 생활을 이어가시길
                  바랍니다.
                  <br />
                  언제나 후원한잔은 여러분과 함께하겠습니다. 갑사합니다 :)
                </ReLoginEndBoxText>
              </ReLoginBlackText>
            </ReLoginContent2>
          </>
        )}

        {/* 회워가입 로그인 버튼 */}
        <ReLoginFlexBox
          $justify="center"
          style={{
            width: `100%`,
          }}
        >
          <LoginSignUpButton2
            $bgColor="#F5A207"
            $hoverBgColor="#F9B535"
            onClick={() => signUpHandle()}
            style={{
              color: `black`,
            }}
          >
            {languageData === "en" ? "Sign up" : "회원가입"}
          </LoginSignUpButton2>
          {/* <ReLoginSizeBox $width="10%" />
          <LoginSignUpButton onClick={() => loginPageHandle()}>
            {languageData === "en" ? "Log in" : "로그인"}
          </LoginSignUpButton> */}
        </ReLoginFlexBox>
      </ReLoginBodyBox>
      <div
        style={{
          padding: `0px 10%`,
        }}
      >
        <ReFooter
          termsLink="/termosfuseCrEn"
          personalInfoLink="/personalInfoEn"
        />
        <ReLoginSizeBox $height="40px" />
      </div>
    </ReLoginBackground>
  );
};

export default ReLoginPage;
